import { LicenseBillingStatus } from "../../constants/licenses";
import { cn } from "../../lib/utils";
import { calculateDiffDays, concatTime } from "../../utils/date";

export function LicenseDaysToExpiration({ license, dueDate = null, ...props }) {
   if (!license || !license.currentBilling) {
      return (
         <span className="opacity-50">Não consta</span>
      );
   }

   const billing = (license.currentBilling.status !== LicenseBillingStatus.PAID || !license.nextBilling) ? license.currentBilling : license.nextBilling;
   const diffDays = calculateDiffDays(new Date(), new Date(concatTime(dueDate ?? billing.dueDate)));

   return (
      <>
         <span className={cn("text-[15px]!", props.className)}>
            {diffDays < 0 ? 'Há ' : ''}{Math.abs(diffDays)} dias
         </span>
      </>
   )
}